/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AddUserToGroupDto interface.
 */
export function instanceOfAddUserToGroupDto(value) {
    return true;
}
export function AddUserToGroupDtoFromJSON(json) {
    return AddUserToGroupDtoFromJSONTyped(json, false);
}
export function AddUserToGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'targetUserId': json['targetUserId'] == null ? undefined : json['targetUserId'],
        'email': json['email'] == null ? undefined : json['email'],
        'permissionId': json['permissionId'] == null ? undefined : json['permissionId'],
        'permissionLevel': json['permissionLevel'] == null ? undefined : json['permissionLevel'],
    };
}
export function AddUserToGroupDtoToJSON(json) {
    return AddUserToGroupDtoToJSONTyped(json, false);
}
export function AddUserToGroupDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'targetUserId': value['targetUserId'],
        'email': value['email'],
        'permissionId': value['permissionId'],
        'permissionLevel': value['permissionLevel'],
    };
}
